export default "__VITE_ASSET__f7cf5dac__"